var Impaginatore = new Class({
	Implements : [Options, Events],
    ImplementObserver: GS.Observer,
    Logger:['log','error','warn','info','group','groupEnd','time','timeEnd'],
	
	options : {
		page_left_id : null,
		page_right_id : null
	},
	initialize : function(options) {
		// vedo se ci sono modifiche da salvare
                var self=this;
		this.modified = false;
    	this.correctWayToGoBack = false;

		// devo tener traccia di chi sia il nodo origine
		this.sortThumb = null;

		// zoom area lavoro
		this.zoom = 1;

		/*for(var i = 0; i < bookDef.spreads.length; i++){
                    try{
                        bookDef.spreads[i].index = i;
                    }catch(err){
                        console.warn(bookDef.spreads,bookDef.spreads[i]);
                    }
                }*/
                var _sID = 0,
                    filteredSpreads = [];
                bookDef.spreads.map(function(spread, i){
                    if(spread){
                        spread.index = _sID;
                        filteredSpreads[_sID] = spread;
                        _sID++;
                       
                        return spread;
                    }
                });
                bookDef.spreads = filteredSpreads;
                //console.warn(nSpreads);
                //this.workArea=this.gs_book.getWorkingArea();
               
		var pageNumberCorrector = 0;
		switch (currentDesign.product_type){
            case 3:
                pageNumberCorrector = 1;
                break;
            case 2:
                pageNumberCorrector = -1;
                break;
        }
		this.gs_book=this.currentSpreadClass=new GS.Book(bookDef,{'debug':0,'current_spread': (window.currentDesign && window.currentDesign['page_index']) ? window.currentDesign['page_index'] : 0 , 'pageNumberCorrector' : pageNumberCorrector});
                //this.gs_book.book_def.minSpreads = 10;
                //this.gs_book.book_def.maxSpreads = 50;
                this.gs_book.addEvent('book:update',function(i){ 
                    this.modified = true;
                    this.updateImagesUsage();
                    //window.fireEvent('designer:updateImagesUsage');
                    //self.renderCurrentThumbnail(i)
                }.bind(this));
                
                //Update current spread indx in case of sort using current displayed spread...
                this.register('current_spread:set',function(i){
                    //console.debug('Set current spread to',i);
                    self.currentSpread=i;
                });
                

		

		// funzioni bindate per una successiva distruzione dei listener
		this.binds = {};
		// gestore della history per fare undo... max 10 livelli 
		this.history = [];

		// elemento che contiene lo spread
		this.spreadRaph = null;

		// spread corrente
		this.currentSpread = 0;
		this.setOptions(options);

		this.createComponents();
		this.addEvents();

		// istanzio la toolbar principale
		this.finishInitialize = function() {
			//window.fireEvent('designer:LoadComplete');
			this.updateImagesUsage();
                        if(window.currentDesign && window.currentDesign['page_index']){
                        }
		};
                
		this.finishInitialize.delay(1, this);
               // this.save.periodical(1000 * 60 * 2,this);
	},
        
        requireSave : function(){
            return this.gs_book.require_save;
        },
        
	addEvents : function() {
		$('thumbnails').addEvent("dragleave", function(e) {
			e.preventDefault();
			return false;
		}, false);

		$('thumbnails').addEvent('dragenter', function(e) {
			e.preventDefault();
			return false;
		});

		$('thumbnails').addEvent('dragover', function(e) {
			e.preventDefault();
			return false;
		});

		$('thumbnails').addEvent('drop', function(e) {
			e.preventDefault();
			return false;
		});
		if($('hide_used')){
                    $('hide_used').addEvent('click', function(e) {
                        e.stop();
                        window.fireEvent("designer:toggleImagesUsed");
                    });
                }
        		
		this.binds.renderCurrentThumbnail = this.renderCurrentThumbnail.bind(this);
		// pulsante pagina precedente
		this.binds.navPrevSpread = this.prevSpread.bind(this);
		window.addEvent("nav:prevSpread", this.binds.navPrevSpread);

		// pulsante salva
		this.binds.save = this.save.bind(this);
		//window.addEvent("impaginatore:save", this.binds.save);

		// pulsante pagina sucessiva
		this.binds.navNextSpread = this.nextSpread.bind(this);
		window.addEvent("nav:nextSpread", this.binds.navNextSpread);

		// spread specifico
		this.binds.navToSpread = this.toSpread.bind(this);
		window.addEvent("nav:toSpread", this.binds.navToSpread);

		// duplica spread
		this.binds.duplicateSpread = this.duplicateSpread.bind(this);
		window.addEvent("pageUtils:duplicateSpread", this.binds.duplicateSpread);

		this.binds.autoFillImages = this.autoFillImages.bind(this);
		window.addEvent('impaginatore:autoFill', this.binds.autoFillImages);

		window.addEvent('resize', this.onResize.bind(this));

		window.onbeforeunload = function() {
			if(!this.correctWayToGoBack) return "Please use back to order form button";
		}.bind(this);

		this.pageContainer.addEvent('dragenter', function(e) {
			e.preventDefault();
			return false;
		});

		this.pageContainer.ondragover = function(e) {
			e.preventDefault();
			return false;
		};

		this.pageContainer.addEvent('click', function(e) {
			if(e && e.target && e.target.parentNode && (e.target.parentNode.getAttribute("id") == "pageContainer" || e.target.parentNode.getAttribute("id") == "center"))
				if(!e.shift)
				window.fireEvent("spread:nodesBlur");
		}.bind(this));

		// ascolto se devo ricontrollare i numeri immagine
		this.binds.updateImagesUsage = this.updateImagesUsage.bind(this);
		window.addEvent('designer:updateImagesUsage', this.binds.updateImagesUsage);
		
		this.binds.toggleImagesUsed = this.toggleImagesUsed.bind(this);
        window.addEvent('designer:toggleImagesUsed', this.binds.toggleImagesUsed);
        
        this.binds.filterBy = this.filterBy.bind(this);
        window.addEvent('designer:filterBy', this.binds.filterBy);
        
        this.binds.orderBy = this.orderBy.bind(this);
        window.addEvent('designer:orderBy',this.binds.orderBy);
        
		this.binds.historyBack = this.historyBack.bind(this);
		window.addEvent('impaginatore:historyBack',this.binds.historyBack);

		this.binds.addToHistory = this.addToHistory.bind(this);
		window.addEvent('impaginatore:addToHistory',this.binds.addToHistory);
		
		this.binds.invertSpreadElements = this.invertSpreadElements.bind(this);
		window.addEvent('impaginatore:invertCurrentSpread',this.binds.invertSpreadElements);

	    // ################## inizio impostazione eventi per gli shortcut
	    
	/*if(Browser.Platform.mac){ // per il MAC
            console.info('use MAC');
        } else { // per i PC
            console.info('use PC');
        }*/    
        
	    
	    var event_prevent = function(e) {
           e.preventDefault();
           console.info('TASTO: '+e.key+' CODE: '+e.code);
        }     
	    var funct_prev = function(e) {
           event_prevent(e);
           window.fireEvent("nav:prevSpread");
        } 
        var funct_next = function(e) {
           event_prevent(e);
           window.fireEvent("nav:nextSpread");
        } 
     
        /*var keyboard = new Keyboard({
            defaultEventType : 'keydown',
            events : {
                'control+d' : function(e) {
                    event_prevent(e);
                    window.fireEvent('gFrame:rimuovi');
                },
                'save' : function(e) {
                    event_prevent(e);
                    window.fireEvent('impaginatore:save');  
                },    
                
                'up' : function(e) {funct_prev(e)},
                'pageup' : function(e) {funct_prev(e)},
                'left' : function(e) {funct_prev(e)},
               
                'down' : function(e) {funct_next(e)},
                'pagedown' : function(e) {funct_next(e)},
                'right' : function(e) {funct_next(e)},
                
                'control+z' : function(e) {
                    event_prevent(e);
                    window.fireEvent('impaginatore:historyBack');
                    //myKeyboard.relinquish(); esegue il comando precedente dato da tastiera, se esiste
                },
                'control+y' : function(e) {
                    event_prevent(e);
                    window.fireEvent('impaginatore:addToHistory');
                }       
            }
        });*/
        
        //keyboard.activate(); // attiva i listener per la tastiera
     
		// ################## fine impostazione eventi per gli shortcut
		
		this.binds.setNewEffect = this.setNewEffect.bind(this);
		window.addEvent('impaginatore:setNewEffect',this.binds.setNewEffect);
		
		this.binds.setNewSample = this.setNewSample.bind(this);
		window.addEvent('impaginatore:setNewSample',this.binds.setNewSample);
	},
	invertSpreadElements : function(){
		this.currentSpreadClass.fireEvent('spread:invert');
	},
	historyBack : function(){
                //console.log('History Back....');
		var element = this.history.shift();
		if(element){
			var page = element.page;
			var spreadId = element.index;
			var changeType = element.type;
			var currentSpread = this.gs_book.book_def.spreads[page];
			switch (element.type){
				case "dispose":
					currentSpread.elements.splice(spreadId, 0, element.oldValues);
				break;
				default : 
					currentSpread.elements[spreadId] = element.oldValues;
			}
			this.renderSpread();
		}
		
	},
	
	addToHistory : function(elem){
                
		this.history.unshift(elem);
	},
	removeEvents : function() {
		window.removeEvent("nav:nextPage", this.binds.navNextPage)
		window.removeEvent("nav:prevPage", this.binds.navPrevPage)
	},
	createComponents : function() {
            
		window.fireEvent('designer:LoadUpdate', {
			perc : 20,
			text : 'creating components'
		});
                
                
                
                if(this.gs_book.book_def) {
                    this.gs_book.book_def.debug=1;
                    this.gs_book.book_def.svg_wrapper='#pageWrapper';
                    this.gs_book.book_def.setWindowResizerLister=false;
                }
                this.pageContainer=$('pageWrapper');
                
                this.workArea=this.gs_book.getWorkingArea();
                if(this.workArea) this.workArea.set("id", "pageContainerSVG");

				if(this.workArea) this.initThumbs();
                
                window.fireEvent('designer:LoadUpdate', {perc : 40,text : 'rendering spread'});
                window.fireEvent('designer:LoadUpdate', {perc : 70,text : 'fitting layout to working area'});
                window.fireEvent('designer:LoadUpdate', {perc : 100,text : 'completed'});
                

		

	},
        renderSpread : function(undoEl) {
                this.console.warn('renderSpread@impaginatore is currently deprecated...');
                return;
                
                $('pageContainer').empty();
                this.workArea = null;
                this.workArea = Raphael(this.pageContainer,this.gs_book.book_def.width,this.gs_book.book_def.height);
		// pulizie di pasqua
		window.fireEvent("spread:clean");
		// viene catturato dai gframe che puliscono tutte le loro cragne
		window.fireEvent("spread:nodesBlur");
		if(this.currentSpreadClass) this.currentSpreadClass.dispose();
		// e avanti
		this.currentSpreadClass = new Spread(this.workArea, this.gs_book.book_def.spreads[this.currentSpread],
		// valori di default del libro se non definiti nel singolo spread
		{
			width : this.gs_book.book_def.width,
			height : this.gs_book.book_def.height,
			backgroundColor : this.gs_book.book_def.backgroundColor,
			realWidth : this.gs_book.book_def.realWidth,
			realHeight : this.gs_book.book_def.realHeight
		});
		this.currentSpreadClass.addEvent("spread:save", function(spread) {
			this.modified = true;
			this.gs_book.book_def.spreads[this.currentSpread] = spread;
			this.binds.renderCurrentThumbnail();
		}.bind(this));
		this.zoomTo(this.zoom);
		this.refreshAllThumbnails();
		// salvo sui cambi pagina
		this.save();
	},
        
	nextSpread : function() {
		// rimuovo i listeners dei componenti di questo spread
		this.fireRemoveListeners();
		
		if(this.currentSpread >= this.gs_book.book_def.spreads.length - 1)
			return false;
		// setto il numero spread corrente al prossimo
		this.currentSpread++;
                
		//$('currSpread').value = this.currentSpread + 1; commentato perchè non più in uso
		this.renderSpread();
	},
	prevSpread : function() {
		this.fireRemoveListeners();
		if(this.currentSpread < 1)
			return false;
		// setto il numero spread corrente al prossimo
		this.currentSpread--;
		//$('currSpread').value = this.currentSpread + 1; commentato perchè non più in uso
		this.renderSpread();
	},
	toSpread : function(index,undoEl) {
		if(index < 0 && index >= this.gs_book.book_def.spreads.length - 1)
			return false;
		this.fireRemoveListeners();
		if($$('#pageThumbs .selected')[0]){
			$$('#pageThumbs .selected')[0].removeClass('selected');
		}
		// setto il numero spread corrente al prossimo
		this.currentSpread = index;
		//$('currSpread').value = index;
		this.renderSpread(undoEl);
	},
	
	fireRemoveListeners : function() {
		window.fireEvent("spread:killListeners");
	},
	fireCleanSpreadThumbs : function() {
		window.fireEvent("spread:cleanThumbs");
	},
	zoomTo : function(x) {
		this.zoom = x;
		this.currentSpreadClass.zoomTo(x);
		this.onResize();
	},
	onResize : function() {
		/*var dimensions = this.pageContainer.getDimensions();
		var spreadDims = this.currentSpreadClass.getDimensions();
		var width = dimensions.width > spreadDims.width * this.zoom ? dimensions.width : spreadDims.width * this.zoom;
		var height = dimensions.height > spreadDims.height * this.zoom ? dimensions.height : spreadDims.height * this.zoom;
		
		var x = 0;
		var y = 0;

		var scrollX = 0;
		var scrollY = 0;
		// centro orizzontalmente
		if(dimensions.width > spreadDims.width * this.zoom) {
			x = dimensions.width / 2 - (spreadDims.width * this.zoom) / 2;
		} else {
			// posiziono a 0 e poi scrollo al centro
			scrollX = ((spreadDims.width * this.zoom - dimensions.width) / 2);
		}

		// centro verticalmente
		if(dimensions.height > spreadDims.height * this.zoom) {
			y = (dimensions.height - spreadDims.height * this.zoom) / 2;
		} else {
			// posiziono a 0 e poi scrollo al centro
			scrollY = ((spreadDims.height * this.zoom - dimensions.height) / 2);
		}

		this.pageContainer.scrollTo(scrollX, scrollY);

		//this.currentSpreadClass.setPosition(x / this.zoom, y / this.zoom);

		// gestisco le dimensioni delle scrollbar
		if(!((y + spreadDims.height * this.zoom) > (height - 18)))
			height -= 18;

		if(!((x + spreadDims.width * this.zoom) > (width - 16)))
			width -= 16;
			
		//this.workArea.setSize(width, height);*/
	},
	autoFillImages : function() {
		var thumbs = $('thumbnails').getElementsByClassName('thumb_img');
		// spread corrente
		var spread = -1;
		// se lo spread è completo
		var compSpread = true;
		// gframes dello spread corrente
		var gframes = new Array();

		for(var i = 0; i < this.gs_book.book_def.spreads.length; i++) {
			for(var l = 0; l < this.gs_book.book_def.spreads[i].elements.length; l++) {
				if(this.gs_book.book_def.spreads[i].elements[l].type == "frame") {
					gframes.push([i, l]);
				}
			}
		}

		for(var c = 0; (c < thumbs.length && c < gframes.length ); c++) {

			var src = thumbs[c].url;
			var parts = /^(.*)\|(\d+)\,(\d+)$/.exec(src);
			var img = new Image();
			img.src = parts[1];
			img.width = parts[2];
			img.height = parts[3];
			var gframe = this.gs_book.book_def.spreads[gframes[c][0]].elements[gframes[c][1]];
			var fit = this.getFitImageDimensions(img, gframe.width, gframe.height);
			//console.log("Fit => ",img,fit);
			src = img.src;
			src = src.replace(/thumbs/ig, "proxy");
			if(src.match(/flickr/ig)) {
				src = src.replace(/_m.jpg/, "_b.jpg");
			}
			this.gs_book.book_def.spreads[gframes[c][0]].elements[gframes[c][1]].image = {
				path : src,
				x : 0,
				y : 0,
				width : fit[1],
				height : fit[0],
				realWidth : parts[2],
				realHeight : parts[3],
				fitWidth : fit[1],
				fitHeight : fit[0]
			};
		}

		this.modified = true;

		this.renderSpread();
		this.refreshAllThumbnails()
		this.updateImagesUsage();
	},
	getFitImageDimensions : function(image, rwidth, rheight) {
		var ratio;
		var imgHeight , imgWidth;
		if(image.naturalHeight > 0 && image.naturalHeight > 0){ 
                    imgHeight = image.naturalHeight;
                    imgWidth = image.naturalWidth;
                    ratio = image.naturalHeight / image.naturalWidth;
		} else { 
                    imgHeight = image.height;
                    imgWidth = image.width;
                    ratio = image.height / image.width;
		}

		var width, height;
		// se il rapporto tra le larghezze è inferiore a quello tra le altezze
		if(imgWidth / rwidth < imgHeight / rheight) {
			// devo fare il fit in larghezza
			width = rwidth;
			height = rwidth * ratio;
		} else {
			height = rheight;
			width = rheight / ratio;
		}
		return [height, width]
	},
	renderCurrentThumbnail : function() {
		this.renderThumbnail(this.currentSpread);
	},
	renderThumbnail : function(spread) {
            return;
            var scale = 0.10;
            var rap = $("thumbsRenderer");
            
            var thumb = document.getElements('.pageThumbWrapper')[spread];
            var thumbW = thumb.getElement(".pageThumbImageWrapper");
            thumbW.empty();
            rap.setStyle("width", Math.round(this.gs_book.book_def.width * scale));
            rap.setStyle("height", Math.round(this.gs_book.book_def.height * scale));

            //if(this.isThumbVisible(thumb)){

            raphs = Raphael(rap,Math.round(this.gs_book.book_def.width * scale),Math.round(this.gs_book.book_def.height * scale));
            currThumbnail = new spreadThumbs.Spread(raphs, this.gs_book.book_def.spreads[spread],
            // valori di default del libro se non definiti nel singolo spread
            {
                width : this.gs_book.book_def.width,
                height : this.gs_book.book_def.height,
                backgroundColor : this.gs_book.book_def.backgroundColor,
                realWidth : this.gs_book.book_def.realWidth,
                realHeight : this.gs_book.book_def.realHeight
            }, scale);
            thumbW.adopt(raphs.canvas);

            var canDims = raphs.canvas.getSize();
            /*thumbW.setStyles({
                width : spread == 0 ? canDims.x / 2 : canDims.x,
                height : canDims.y
            });*/

            thumb.visible = true;
	},
        createAllThumbnails : function(){
            for(var i = 0; i < this.gs_book.book_def.spreads.length; i++) {
                this.renderThumbnail(i);
            }
        },
	refreshAllThumbnails : function() {
		/*for(var i = 0; i < this.gs_book.book_def.spreads.length; i++) {
			this.renderThumbnail(i);
		}*/
	},
	initThumbs : function() {
            //var t = new GS.Thumbnails(bookDef,{debug:0});
            
            /*var _this = this;
            $('pageThumbs').empty();
            for(var i = 0; i < this.gs_book.book_def.spreads.length; i++) {
                var wrp = new Element('div', {
                    'class' : 'pageThumbWrapper'
                });
                wrp.addEvent('click',function(){
                    changePage(this.index);
                });
                if( i == 0 ) wrp.addClass('selected');
                wrp.index = i;
                var imgWrp = new Element('div', {
                    'class' : 'pageThumbImageWrapper'
                });

                var label = this.gs_book.book_def.spreads[i].type == 'front-cover' ? 'cover' : i;
                var p = new Element('p', {
                    html : label
                });

                wrp.adopt(imgWrp, p);
                $('pageThumbs').adopt(wrp);
                if(i < this.gs_book.book_def.spreads.length - 1 ){
                    var btnContainer = new Element('div',{
                        styles : {
                            height : 95,
                            'float':'left',
                            'padding-top':33
                        }
                    });
                    var addBtn = new Element('div',{
                        'class' : 'addPageBtn'
                    });
                    addBtn.pageIndex = i;
                    addBtn.addEvent('click',function(a){
                        _this.addPageAfter(this.pageIndex);
                    });
                    btnContainer.adopt(addBtn);
                    $('pageThumbs').adopt(btnContainer);
                }
            }
            this.createAllThumbnails();
            $$('.ui-layout-south').setStyle('zIndex', 1);*/
	},
	isThumbVisible : function(el) {
		var container = el.parentNode;
		var offset = 600;
		// carico anche le prossime non visibili per evitare caricamenti orribili
		return ((el.offsetTop + el.offsetHeight + offset ) > container.scrollTop) && ((el.offsetTop - offset) < (container.scrollTop + container.offsetHeight )
		);
		return true;
	},
	sortSpreads : function(from, to) {
		if(to == 0)
			return false;

		var def = this.gs_book.book_def.spreads.splice(from,1)[0];

		this.gs_book.book_def.spreads.splice(to, 0, def);

		this.refreshIndexes();
	},
	duplicateSpread : function() {
		if(this.currentSpread == 0)
			return false;
		var copy = JSON.decode(JSON.encode(this.gs_book.book_def.spreads[this.currentSpread]));
		this.gs_book.book_def.spreads.splice(this.currentSpread + 1, 0, copy);

		this.refreshIndexes();
		this.initThumbs();
	},
	refreshIndexes : function() {
		for(var i = 0; i < this.gs_book.book_def.spreads.length; i++)
		bookDef.spreads[i].index = i;
	},
	renderRulers : function() {
		this.rulers = new Rulers(this);
	},
	save : function() {
            //console.log(this.options.readonly);
            if(this.options.readonly) return false;
            var url = app_base + "designed/" + currentDesign.id + "/"+currentDesign.customer+"/save";
            if(this.modified) {
                var myJSONRemote = new Request.JSON({
                    url : url,
                    onSuccess : function() {
                        this.modified = false;
                    }.bind(this)
                }).post({
                    book : JSON.encode(this.gs_book.book_def)
                });
            }
	},
	// restituisce un array con tutte le immagini usate
	getUsed : function() {
        
        // spread corrente
        var spread = -1;
        // gframes dello spread corrente
        var gframes = new Array();
        var images = {}; // inizializzo l'oggetto images

		if(!this.gs_book || !this.gs_book.book_def) return images;
        
        for(var i = 0; i < this.gs_book.book_def.spreads.length; i++) {
            for(var l = 0; l < this.gs_book.book_def.spreads[i].elements.length; l++) {
                if(this.gs_book.book_def.spreads[i].elements[l].type == "frame") { // il tipo frame è il tipo di elemento dello spread che può contenere un'immagine
                    gframes.push(this.gs_book.book_def.spreads[i].elements[l]); // aggiungo tutti i frame
                }
            }
        }
        
        for(var c = 0; (c < gframes.length ); c++) {
            
            var gframe = gframes[c];
               if (gframe.image && gframe.image.path && gframe.image.path.indexOf("get_design_background") === -1) { // se èun'immagine e non è un'immagine usata come background

                    var src = gframe.image.path;
                    var parts = /^.*\/(\d+)$/.exec(src);
                    src = (parts) ? parts[1] : ''; // ottengo il nome dell'immagine
    
                    if(!images[src]) {
                        images[src] = 0;
                    }
                    images[src]++;
                }
        }
        return images;
        
    },    
    // aggiorna l'utilizzo delle immagini nella barra thumbs
    updateImagesUsage : function() {
       $$('.thumbnail').each(function(el) { // ciclo tutte le miniature
            if(el.getElement('.thumb_counter')){
                el.getElement('.thumb_counter').set('html', 0); // azzero tutti contatori delle miniature usate
                el.getElement('.thumb_counter').setStyle('background', '#999')
            }
        })
      
        var images_used = this.getUsed(); // images è l'array che contiene tutte le immagini usate
        for (var img in images_used) {
            if($("thumb_" + img)) {
                var el = $("thumb_" + img).getElement('.thumb_counter');
                el.set('html', images_used[img] ? images_used[img] : 0);
                if(images_used[img] == 1)
                    el.setStyle('background', '#8B4')
                else if(images_used[img] > 1)
                    el.setStyle('background', '#DA4')
            } else {
//                console.info(img)
            }
        };
    },
    // nascondo le immagini usate o le mostro a seconda di cosa sceglie il cliente
    toggleImagesUsed : function(arrayImageUsed) {

       $$('.thumbnail').each(function(el) { // ciclo tutte le miniature
           
           if (el.getStyle('display')=="none") { // se c'è un elemento nascosto, lo mostro
               
               /*
                * ABILITARE SE SI VUOL RIDURRE LO SPAZIO OCCUPATO DALL'IMMAGINE NASCOSTA
                el.show(); // prima metto display block e poi parte il fade che la mostra
                */
               el.show();
            }
        }); // chiuso il ciclo delle miniature
        if($('hide_used')){
            if (!$('hide_used').hasClass('hide')) {  // se devo nascondere quelle usate, e quindi il bulsante Mostra/Nascondi non ha la classe hide
                $('hide_used').set('html',"Show All");
                var images_used = (arrayImageUsed) ? arrayImageUsed : this.getUsed(); // se ho già l'array che contiene tutte le immagini usate, nel caso sia stata chiamata la funzione updateImagesUsage 
                for (var img in images_used) {
                   if ($("thumb_" + img)) {
                        var el = $("thumb_" + img);
                        el.hide();   
                    }
                 } // chiuso il for delle immagini usate
                 $('hide_used').addClass('hide');
            } else {
                $('hide_used').set('html',"Hide Used");
                $('hide_used').removeClass('hide');
            }
       }//chiuso if che controlla se esiste $(#hide_used);
       resize();
    },
    // rimuovo immagini
	removeImages : function(images) {
		// spread corrente
		var spread = -1;
		// gframes dello spread corrente
		var gframes = new Array();
		for(var i = 0; i < this.gs_book.book_def.spreads.length; i++) {
			for(var l = 0; l < this.gs_book.book_def.spreads[i].elements.length; l++) {
				if(this.gs_book.book_def.spreads[i].elements[l].type == "frame") {
					var gframe = this.gs_book.book_def.spreads[i].elements[l];
					if(gframe.image) {
                        if(gframe.image.path){
                            var src = gframe.image.path;    
                            var parts = /^.*\/(\d+)$/.exec(src);
                            src = parts[1];
                            for(var c = 0; c < images.length; c++) {
                                if(images[c] == src)
                                    gframe.image = null;
                            }
                        }
					}
				}
			}
		}
		this.renderSpread();
		this.refreshAllThumbnails();
	},
    filterBy : function(filterString) {
        var filterValue = filterString.filterValue;
        if(filterValue == 'All'){
            $('thumbnails').getElements('.thumbnail').show()
        } else {
            var els = $('thumbnails').getElements('.thumbnail');
            Array.each(els,function(el,index){
                if (!el.hasClass(filterValue)){
                    el.hide();
                } else {
                    el.show();
                }
            })
        }
        resize();
    }, 
    orderBy : function(order){
        $('thumbnails').empty();
        var order_field = order.orderField;

        //uploadManager.loadInitialImages(order_field);
    },
	setNewEffect : function(effect_data){
		spread_config = this.gs_book.book_def.spreads[this.currentSpread];
		if (spread_config.type == "front-cover") return false;
		var oldImages = [];	
		var jsonData = JSON.decode(effect_data);
		Array.each(spread_config.elements,function(el,index){
			if(el.image){
				if(el.image.path.indexOf('get_design_background') === -1){
					if(jsonData[index]){
						delete el.image.fitHeight;
						delete el.image.fitWidth;
						el.image.height = jsonData[index].height;
						el.image.width = jsonData[index].width;
						el.image.recalculateFitSize = true;
						jsonData[index].image = el.image;
					}
				}
			}
		}.bind(this));
		this.gs_book.book_def.spreads[this.currentSpread].elements = jsonData;
		this.renderSpread();
	},
	setNewSample : function(sample_data){
		spread_config = this.gs_book.book_def.spreads[this.currentSpread];
		if (spread_config.type == "front-cover") return false;
		var oldImages = [];	
		var jsonData = JSON.decode(sample_data);
		Array.each(spread_config.elements,function(el,index){
			if(el.type == "frame"){
				if(el.image){
				    oldImages.push(el.image);
				}
			}
		}.bind(this));
		Array.each(oldImages,function(el,index){
		    for (var i = 0; i < jsonData.length;i++){
		        var jsonEl = jsonData[i];
		        if(jsonEl.type == "frame" && !jsonEl.image){
                            jsonEl.image = el;
                            break;
                        }
                    }
		}.bind(this));
		this.gs_book.book_def.spreads[this.currentSpread].elements = jsonData;
		this.renderSpread();
	},
        addPageAfter : function(preIndex){
            this.dispatch('spread:add',preIndex);
            this.initThumbs();
            this.currentSpread=preIndex+1;
            return;
            //console.log('Add Page After: %s',preIndex);
            
            var index = preIndex + 1;
            var newElement = {
                width : 1000,
                height : 683,
                index : index,
                elements : []
            };
            this.gs_book.book_def.spreads.splice(index,0,newElement);
            this.initThumbs();
            changePage(index);
        },
        addPageAfterCurrent : function(){
            var currentPage = this.currentSpread;
            this.addPageAfter(currentPage);
        },
        addPageBeforeCurrent : function(){
            var currentPage = this.currentSpread;
            currentPage--;
            this.addPageAfter(currentPage);
        }
});
